var exports = {
  "w": "xe533113f--2309a2--carousel--empty",
};

module.exports = exports;
